import { TableActions } from '../components/TableActions';

export const getColumns = () => [
    {
        title: 'Владелец',
        dataIndex: 'user_id',
        key: 'user_id',
        render: text => text,
    },
    {
        title: 'Магазин',
        dataIndex: 'name',
        key: 'name',
        render: text => text,
    },
    {
        title: 'Создан',
        dataIndex: 'created_at',
        key: 'created_at',
        render: text => text,
    },
    {
        title: 'Тип магазина',
        dataIndex: 'type',
        key: 'type',
        render: text => text,
    },
    {
        title: 'ID магазина',
        dataIndex: 'id',
        key: 'id',
        render: text => text,
    },
    {
        title: 'Кастомизация',
        dataIndex: 'is_custom',
        key: 'is_custom',
        render: text => text,
    },
    {
        title: '',
        render: text => <TableActions {...text} />,
    },
];
